/**
 * Created by lihanying on 2017/6/23.
 */
import { API_DOMAIN } from '../../config'
import 'whatwg-fetch'
import { fetchData, postData } from '../../util/index'
import { GETCLUBLIST } from './constants'

export const getClubList = (payload) => {
  return {
    type: GETCLUBLIST,
    payload,
  }
}

//俱乐部
export function fetchClubList(callback) {
  return (dispatch, getState) => {
    const endpoint = `${API_DOMAIN}/SetClubApi/UserClubList`
    return fetchData(endpoint)
      .then((data) => {
        if (data && 'list' in data && data.list.length > 0) {
          console.log('in fn')
          const cid = sessionStorage.getItem('club_id')
          for (let i = 0; i < data.list.length; i++) {
            console.log('in for')
            if (data.list[i].id == cid) {
              console.log(data.list[i])
              sessionStorage.setItem(
                'is_new_invoicing',
                data.list[i].is_new_invoicing
              )
              sessionStorage.setItem(
                'club_testing',
                data.list[i].testing ? 1 : 0
              )
              sessionStorage.setItem('club_name', data.list[i].club_name)
              sessionStorage.setItem('role_id', data.list[i].role_id)
            }
          }
          if (!cid || cid == '') {
            const item = data.list[0]
            sessionStorage.setItem('club_name', item.club_name)
            sessionStorage.setItem('club_id', item.id)
            sessionStorage.setItem('user_account', item.account)
            sessionStorage.setItem('role_id', item.role_id)
            sessionStorage.setItem('is_new_invoicing', item.is_new_invoicing)
            sessionStorage.setItem('club_testing', item.testing ? 1 : 0)
          }
        }
        dispatch(getClubList(data.list))
        return data
      })
      .then(() => {
        callback && callback()
      })
  }
}

//搜索
export function searchData(keyword = false) {
  return (dispatch, getState) => {
    const data = getState().getHome.clubList
    let searchResult = []
    if (data && keyword !== false) {
      searchResult = data.filter(
        (item) => item.club_name.indexOf(keyword) !== -1
      )
    }
    dispatch(getClubList(searchResult))
  }
}



// WEBPACK FOOTER //
// ./src/containers/Home/action.js